/*** IMPORTS FROM imports-loader ***/
var loadTerrific = require("bootstrap/load-terrific");
var Tc = loadTerrific.default;
(function() {
var window = this;
var window = (window || {});
window.Tc = Tc;

(function (Module, $) {
	'use strict';

	/**
	 * Card.
	 *
	 * @author TAAATRA1
	 * @namespace Tc.Module
	 * @class Card
	 * @extends Tc.Module
	 */
	Module.Card = Module.extend({

		on: function (callback) {
			var $ctx = this.$ctx;

			if($ctx.hasClass('cardClickable')) {
				$ctx.on('click', $.proxy(this.handleClick, this));
			}
			if($ctx.hasClass('selected')) {
				this.handleClick();
			}

			$ctx.closest('.link > a').css('text-decoration', 'none');

			callback();
		},

		handleClick: function () {
			var $ctx = this.$ctx;
			if($ctx.hasClass('active')) {
				return;
			}
			var $parentGrid = $ctx.closest('.modGridLayout, .gridlayout');
			var onetimeCharge = $ctx.data('onetime-charge'),
				monthlyPriceCharge = $ctx.data('price'),
				$input = $ctx.find('input');

			$parentGrid.find('.modCard.cardClickable').removeClass('active selected').removeAttr('style');
			$parentGrid.find('.modCard.cardClickable input').val('').removeAttr('data-onetime-charge data-price');
			$ctx.addClass('active');
			$input.val($ctx.data('active-value'));
			if(onetimeCharge) {
				$input.attr('data-onetime-charge', onetimeCharge);
			}
			else if (monthlyPriceCharge){
				$input.attr('data-price', monthlyPriceCharge);
			}
			this.fire('PriceAdded', {}, ['formpriceupdate']);
		}
	});

}(window.Tc.Module, window.Tc.$));

}.call(window));


//////////////////
// WEBPACK FOOTER
// ./clientlibs/js/etc/designs/portal/clientlibs/shared/js/modules/Tc.Module.Card.js
// module id = 134
// module chunks = 0